import moment from "moment"
import { RowExportTypeExcel } from "types"
import { excel } from "utils"
import { RegisterDateType } from "../types"

export function ExportExcel(props: {
  data: RegisterDateType[],
  filter: {
    dateFrom: string,
    dateTo: string
  },
  title: string,
  fileName: string
}) {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "TRADE ID", key: "trade_id", width: 20 },
    { header: "DATE", key: "date", width: 20 },
    { header: "TRADER", key: "trader", width: 20 },
    { header: "REF NO", key: "ref_no", width: 20 },
    { header: "MRK", key: "mrk", width: 20 },
    { header: "MEMO", key: "memo", width: 30 },
    { header: "LOCATION", key: "location", width: 20 },
    { header: "DEBIT", key: "debit", width: 20 },
    { header: "CREDIT", key: "credit", width: 20 },
  ]

  const dataMap: RowExportTypeExcel[] = props.data.map((item, index) => ({
    no: index + 1,
    trade_id: item.data_source_code + ' ' + item.trx_code,
    date: moment(item.transaction_date).format("DD/MM/YYYY"),
    trader: item.trader,
    ref_no: item.reference_no,
    mrk: (item.reconsiled ? '✔' : '✘') + ' ' + item.mrk,
    memo: item.memo,
    location: item.location_name,
    debit: {
      text: item.position === 1 ? item.amount : "",
      style: {
        alignment: {
          horizontal: 'right'
        },
        numFmt:"#,##0"
      }
    },
    credit:{
      text: item.position === 2 ? item.amount : "",
      style: {
        alignment: {
          horizontal: 'right'
        },
        numFmt:"#,##0",
        font: {
            color: {argb: 'FFFF0000'}
        }
      }
    },
  }))

  excel({
    dataList: dataMap,
    column: columns,
    module: "FINANCE",
    title: props.title,
    fileName: props.fileName,
    date: `${moment(props.filter.dateFrom).format('DD-MM-YYYY')} - ${moment(props.filter.dateTo).format('DD-MM-YYYY')}`
  })
}